
import { defineComponent, ref, PropType, computed } from 'vue'

import { mdiOpenInNew } from '@mdi/js'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import LayoutAuthSidebarContentSubmenu from '@/components/LayoutAuthSidebarContentSubmenu.vue'
import BaseAccordionOpenIcon from '@/components/BaseAccordionOpenIcon.vue'
import { MenuAttributes } from '@/types/models/menu'
import { toArray } from '@/utils/array'
import { validateUrl, externalOrInternalLink, LINK_STATUS } from '@/utils/router'
import { useRoute } from 'vue-router'

export default defineComponent({
  props: {
    menus: {
      type: Array as PropType<MenuAttributes[]>,
      'default': () => ([]),
    }
  },
  components: { BaseSvgIcon, LayoutAuthSidebarContentSubmenu, BaseAccordionOpenIcon },
  setup(props) {
    const route = useRoute()
    const isOpenSubmenu = ref(Array(props.menus.length).fill(true))

    const handleToggle = (index: number) => {
      isOpenSubmenu.value.splice(index, 1, !isOpenSubmenu.value[index])
    }

    const currentUrl = computed(() => {
      return `${route.path}${window.location.search}`
    })

    return {
      isOpenSubmenu,
      handleToggle,
      toArray,
      validateUrl,
      externalOrInternalLink,
      mdiOpenInNew,
      LINK_STATUS,
      currentUrl
    }
  },
})
